import { inventories } from "@/api/inventories/useInventoriesQuery";
import { LocationDetailInForm } from "@/features/location/detail/LocationDetailInForm";
import { Main } from "@/features/standard/Main";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { LeftSpace } from "@/features/standard/detail/LeftSpace";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { Tabs, Text, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { LocationLedgerTabs } from "../tabs/locationLedgerTabs";

const Detail = Object.assign(Main, {
  Container: DetailContainer,
  Wrapper: DetailWrapper,
  Content: DetailContent,
});

interface DetailLocationProps {
  locationCode: string | undefined;
}

export const LocationDetailForm = (params: DetailLocationProps) => {
  const { locationCode } = params;
  const { t } = useTranslation();
  const { data } = useQuery(
    inventories.find({
      query: { $and: [{ locationCode: { $eq: locationCode } }] },
      populate: ["lot", "item"],
    }),
  );

  return (
    <>
      <Detail.Container>
        <Detail.Wrapper>
          <Detail.Content>
            <LocationDetailInForm data={data} />
            <Tabs defaultValue="locationLedger">
              <LeftSpace />
              <Tabs.List>
                <Tabs.Tab value="locationLedger">{t("inventory.record")}</Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value="locationLedger" p={20}>
                <Title order={3}>{t("inventory.record")}</Title>
                <Text size="sm">{t("inventory.recordDescription")}</Text>
                <LocationLedgerTabs locationCode={locationCode} />
              </Tabs.Panel>
            </Tabs>
          </Detail.Content>
        </Detail.Wrapper>
      </Detail.Container>
    </>
  );
};
